import React from 'react'
import {
  VStack,
  Text,
  Stack,
  Button,
  Grid,
  GridItem,
  Heading,
} from '@chakra-ui/react'
import type { Quiz, Stats } from 'types/generated/graphql'
import { LayoutEmbedQuizPlaylist } from 'components/Common/LayoutEmbedQuizPlaylist'

type Props = {
  quiz: Quiz & { answerCandidates: string[] }
  quizNo: number
  quizzesCount: number
  quizStats?: Stats
  onAnswer: (answer: string) => void
}

export const EmbedQuestion: React.FC<Props> = ({
  quiz,
  quizNo,
  quizzesCount,
  quizStats,
  onAnswer,
}) => {
  return (
    <LayoutEmbedQuizPlaylist
      imageUrl={quiz.content.imageUrl!}
      alt={quiz.content.question!}
    >
      <VStack w="100%" spacing={3}>
        <Heading fontSize="xl" mb="1rem" color="white">
          問題{quizNo}/{quizzesCount}
        </Heading>

        <Text fontSize={{ base: 'md', sm: 'lg' }} mb="1rem" color="white">
          Q：{quiz.content.question}
          {quizStats &&
            // statsには[正解、不正解1、不正解2…]の順番で入る
            `(正答率${quizStats.stats[0].percent})`}
        </Text>
        <Stack w="100%" mb="2rem" spacing={4} direction="row" align="center">
          <Grid
            w="100%"
            templateRows={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
            templateColumns={{
              base: 'repeat(1, 1fr)',
              md: 'repeat(4, 1fr)',
            }}
            gap={4}
          >
            {quiz.answerCandidates.map((candidate, index) => (
              <GridItem
                rowSpan={{ base: 1, md: 1 }}
                colSpan={{ base: 1, md: 2 }}
                colorscheme="teal"
                key={'quizAnswerButton-' + index}
              >
                <Button
                  size="lg"
                  w="100%"
                  onClick={() => {
                    onAnswer(candidate)
                  }}
                  bg="whiteAlpha.800"
                >
                  {candidate}
                </Button>
              </GridItem>
            ))}
          </Grid>
        </Stack>
      </VStack>
    </LayoutEmbedQuizPlaylist>
  )
}
